import type { TUrlConnector } from '@/components/Shared/Suite/type.ts';

export function useImagePath(urlConnector?: TUrlConnector) {
  const { isTablet, isDesktop } = useScreen();
  const { provideImgUrl, provideResponsiveImgUrl } = useSolutionsData();

  /**
   * 根據裝置類型回傳對應的響應式圖片檔案名稱
   * @param baseName - 圖片基礎檔名（不含副檔名）
   * @returns 完整的圖片檔案名稱
   */

  const provideResponsiveImgName = (baseName: string): string => {
    if (isDesktop.value) {
      return `${baseName}.webp`;
    }
    if (isTablet.value) {
      return `${baseName}_m.webp`;
    }
    return `${baseName}_s.webp`;
  };

  /**
   * 依據 Suite 元件的資料來源，提供縮圖網址
   * @param thumbnail - 縮圖欄位（檔名或完整網址，視來源而定）
   */

  const provideSuiteThumbnailUrl = (thumbnail: string): string => {
    if (!thumbnail) return '';

    if (urlConnector === 'solution') {
      return provideResponsiveImgUrl(thumbnail);
    }
    return thumbnail;
  };

  /**
   * 依據 Suite 元件的資料來源，提供 logo 網址
   * @param logo - logo 欄位（檔名或完整網址，視來源而定）
   */

  const provideSuiteLogoUrl = (logo: string): string => {
    if (!logo) return '';

    if (urlConnector === 'solution') {
      return `${provideImgUrl(logo)}.webp`;
    }
    return logo;
  };

  return {
    provideResponsiveImgName,
    provideSuiteThumbnailUrl,
    provideSuiteLogoUrl,
  };
}
